var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('router-view'),_c('dashboard-core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }